export function purchaseStoreInitState () {
  return {
    serviceId: -1,
    optionPriceGroup: [],
    service: null, // 服務資訊
    restoredDateTime: null, // 還原的日期時間資料
    selectedData: {
      price: {
        option: {},
        totalPrice: 0,
        error: {}
      },
      option: {
        error: {}
      },
      region: {
        city: {},
        area: {},
        name: '',
        phone: '',
        address: '',
        addressCheckValidate: null,
        selectTabletId: '',
        community: {},
        communityAddress: '',
        communityCheckValidate: null,
        contactFlag: false
      },
      payment: 0,
      recipient: {
        postId: '',
        city: {},
        area: {},
        name: '',
        phone: '',
        address: '',
        addressCheckValidate: null,
        remember: false
      },
      datetime: {
        serviceTimeTypeId: null, // 用於還原時比較 type 是否改變
        date: null,
        dateOpen: false,
        defaultTime: 1,
        timeStartHour: '00',
        timeStartMinute: '00',
        timeStartHourOptions: [],
        timeStartMinuteOptions: [],
        timeEndHour: '00',
        timeEndMinute: '00',
        timeEndHourOptions: [],
        timeEndMinuteOptions: [],
        defaultModeList: [],
        weekdayReservation: 1,
        weekdayOrWeekendModeList: []
      },
      receipt: {
        type: 1,
        mail: '',
        companyMail: '',
        city: '',
        area: '',
        address: '',
        idNumber: '',
        donate: 1,
        barcode: '',
        typeOptions: [
          {
            label: '個人電子發票',
            value: 1,
            InvoiceMark: 1,
            InvoiceCarrierType: 2
          },
          {
            label: '公司統一編號',
            value: 2,
            InvoiceMark: 1,
            InvoiceCarrierType: 1
          },
          {
            label: '捐贈發票',
            value: 3,
            InvoiceMark: 2,
            InvoiceCarrierType: 1
          },
          {
            label: '手機條碼載具',
            value: 4,
            InvoiceMark: 1,
            InvoiceCarrierType: 3
          }
        ],
        donateOptions: [],
        checkboxCheck: false,
        tooltipOpen: false
      },
      photoList: [],
      photoValidate: true,
      channelType: {
        id: 0,
        other: '',
        checkValidate: null
      },
      referrer: {
        name: ''
      },
      note: {
        data: '',
        isError: false,
        errorMessage: ''
      }
    },
    promotion: {
      PromotionDataList: [],
      selectedOptionByPromotionId: {},
      selectingOptionByPromotionId: {}
    },
    contactPickupChecked: false,
    contactPickupFeeList: [],
    isShowCartDialog: false,
    step: -1,
    stepValidateList: [],
    stepObj: null,
    listenStepChange: false, // orderSteps.vue 監聽 state.step 並更新 url 的開關
    // 當 OrderSteps 開始監聽 route query step 變化時會被設為 true
    startListenQueryStepChange: false,
    skipLeaveCheck: false, // purchase.vue 的 beforeRouteLeave 判斷 開關
    skipLeaveStoreState: false, // purchase.vue 的 beforeRouteLeave 離開時段是否清除相關 store
    termChecked: false, // 服務條款已勾選
    btn: {
      isSetOrderLoading: false
    },
    orderResult: {
      title: '',
      message: '',
      btnText: '',
      image: '',
      type: '',
      successData: null,
      routerObj: null,
      plusPayOnMobile: null,
      creditCardBind: null,
      mobilePay: null
    },
    confirmPriceDetail: {
      totalPrice: 0,
      subtotalPrice: 0,
      bonusAmount: 0,
      discountAmount: 0
    },
    orderPriceOptionList: [],
    orderNonPriceOptionList: [],
    hasNonMatchedOptionFromOrder: false,
    hasNonMatchedOptionFromLocalStorage: false
  }
}

export default {
  purchaseStoreInitState
}
